<nv-container>
  <nv-construction-page *ngIf="enableConstructionPage"></nv-construction-page>
  <router-outlet *ngIf="!enableConstructionPage"></router-outlet>
</nv-container>
